import React from 'react'
export const API_BASE_PATH = 'https://perfect-fitness-production-faf512261aa3.herokuapp.com'
export const drawerWidth = 300
import UserIcon from 'src/assets/icons/Usericon.png'
import trainerMembershipIcon from 'src/assets/icons/trainermembershipicon.png'
import walletRequestsIcon from 'src/assets/icons/walletrequestsicon.png'
import saleReportsIcon from 'src/assets/icons/salesreportsicon.png'
import subscriptionReportsIcon from 'src/assets/icons/subscriptionreportsicon.png'
import manageParksIcon from 'src/assets/icons/manageparksicon.png'
import messagesIcon from 'src/assets/icons/messagesicon.png'
import postsIcon from 'src/assets/icons/postsicon.png'
import aiTrainerIcon from 'src/assets/icons/aitrainericon.png'
import notificationsIcon from 'src/assets/icons/notificationsicon.png'
import LogoutIcon from '@mui/icons-material/Logout'
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import InventoryIcon from '@mui/icons-material/Inventory';
export const routeUrls = {
  landingPage: '/',
  login: '/login',
  // register: '/register',
  // forgotPassword: '/forgot-password',
  // termAndCondition: '/term-and-condition',
  // privacyPolicy: '/privacy-policy',
  logout: '/logout',
  home: '/home',
  trainers: '/home/trainers',

  walletRequests: '/home/wallet-requests',
  products: '/home/products',
  saleReports: '/home/sale-reports',
  subscriptionReports: '/home/subscription-reports',
  manageParks: '/home/manage-parks',
  messages: '/home/messages',
  posts: '/home/posts',
  aiTrainer: '/home/ai-trainer',
  notifications: '/home/notifications',
  manageGyms: '/home/manage-gyms',

}

export const localStorageKeys = {
  accessToken: 'accessToken',
  user: 'user',
}

export interface ISidebarMenuItem {
  label: string
  url: string
  icon: React.ReactElement
}

export const sidebarMenuItems: ISidebarMenuItem[] = [
  {
    label: 'Users',
    icon: <img src={UserIcon} alt='Users' />,
    url: routeUrls.home,
  },
  {
    label: 'Products',
    icon: <InventoryIcon color='primary' />,
    url: routeUrls.products,
  },
  {
    label: 'Posts',
    icon: <img src={postsIcon} alt='Posts' />,
    url: routeUrls.posts,
  },
  {
    label: 'Notifications',
    icon: <img src={notificationsIcon} alt='Notifications' />,
    url: routeUrls.notifications,
  },
  {
    label: 'Logout',
    icon: <LogoutIcon color='primary' />,
    url: routeUrls.logout,
  },
]

export const notificationStatus = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
}

export const repeatEveryOptions = [
  { value: 'Do not repeat', label: 'Do not repeat' },
  { value: 'Every day', label: 'Every day' },
  { value: 'Every week', label: 'Every week' },
  { value: 'Every month', label: 'Every month' },
  { value: 'custom', label: 'custom' },
]

export const recipientsOptions = [
  { value: 0, label: 'All' },
  { value: 1, label: 'User' },
  { value: 2, label: 'Trainer' },
]
export const trainingLevelOptions = [
  { label: 'Easy', value: 'Easy' },
  { label: 'Great', value: 'Great' },
  { label: 'Hard', value: 'Hard' },
]

export const timeOptions = Array.from({ length: 60 }, (_, index) => ({
  label: (index + 1).toString() + ' min',
  value: index + 1,
}))

export const PRODUCT_TYPES = ['Supplement', 'Accessories']
export type SubscriptionTypeFilterI = 'TR' | 'AT' | 'PR' | ''
export const SUBSCRIPTION_TYPE_MAP = {
  TR: 'Trainer',
  AT: 'AI Trainer',
  PR: 'Promotion',
}
export const SUBSCRIPTION_TYPES: {
  value: SubscriptionTypeFilterI
  label: string
}[] = [
  { value: '', label: 'All' },
  {
    value: 'TR',
    label: SUBSCRIPTION_TYPE_MAP['TR'],
  },
  {
    value: 'AT',
    label: SUBSCRIPTION_TYPE_MAP['AT'],
  },
  {
    value: 'PR',
    label: SUBSCRIPTION_TYPE_MAP['PR'],
  },
]